/**
 * ふりがな自動入力
 */
 $(function() {
  $.fn.autoKana('#customer_nm', '#customer_kn');
});
